module.exports = __webpack_public_path__ + "static/media/phone-icon.6ab89705.svg";